export enum SubmissionMethod {
    Platform = 'PLATFORM',
    UIBulkDocument = 'UI_BULK_DOCUMENT',
    FieldImportApi = 'FIELD_IMPORT_API',
}
